import React, { useState } from "react";
import Register from "../Register/Register.component.tsx";
import SignIn from "../SignIn/SignIn.component.tsx";
import "./SigninResigsterModal.css";

const SigninResigsterModal = ({ setToken, setUserData, setCurrentPage }) => {
  const [register, setRegister] = useState(false);

  const switchRegSignin = () => {
    setRegister(!register);
  };

  return (
    <div className="signinRegister">
      {!register && (
        <>
          <SignIn setToken={setToken} setUserData={setUserData} />
          <p>need an account?</p>
          <button onClick={switchRegSignin}>Register</button>
        </>
      )}
      {register && (
        <>
          <Register
            setToken={setToken}
            setUserData={setUserData}
            setCurrentPage={setCurrentPage}
          />
          <p>have an account?</p>
          <button onClick={switchRegSignin}>Sign in</button>
        </>
      )}
    </div>
  );
};

export default SigninResigsterModal;
